// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"StraightCardRow_card-wrapper__1Rez3"};